/**
 * Gestione Pratiche API
 * Servizi per la gestione della piattaforma Gestione Pratiche
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { ComuneInfoDTO } from '../model/comuneInfoDTO';
import { ExceptionResponseDTO } from '../model/exceptionResponseDTO';
import { InlineResponse500 } from '../model/inlineResponse500';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class ComuneControllerService {

    protected basePath = 'http://comune.southengineering.it/gestione-pratiche';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * Consente di conoscere le info generali del comune
     * @param id_slug_comune 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getComune(id_slug_comune: string, observe?: 'body', reportProgress?: boolean): Observable<ComuneInfoDTO>;
    public getComune(id_slug_comune: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ComuneInfoDTO>>;
    public getComune(id_slug_comune: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ComuneInfoDTO>>;
    public getComune(id_slug_comune: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id_slug_comune === null || id_slug_comune === undefined) {
            throw new Error('Required parameter id_slug_comune was null or undefined when calling getComune.');
        }

        let headers = this.defaultHeaders;

        // authentication (bearer-token) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ComuneInfoDTO>('get',`${this.basePath}/api/v1/${encodeURIComponent(String(id_slug_comune))}/comune`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Consente di conoscere le info generali del comune
     * @param id_slug_comune 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getComunePublic(id_slug_comune: string, observe?: 'body', reportProgress?: boolean): Observable<ComuneInfoDTO>;
    public getComunePublic(id_slug_comune: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ComuneInfoDTO>>;
    public getComunePublic(id_slug_comune: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ComuneInfoDTO>>;
    public getComunePublic(id_slug_comune: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id_slug_comune === null || id_slug_comune === undefined) {
            throw new Error('Required parameter id_slug_comune was null or undefined when calling getComunePublic.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ComuneInfoDTO>('get',`${this.basePath}/api/v1/${encodeURIComponent(String(id_slug_comune))}/comune/public`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
